import _ from 'underscore';
import $ from 'jquery';

import 'jquery-Mustache';
import 'jquery-hotkeys';

import Backbone from 'backbone';
import AppStorage from './AppStorage';
import AppController from '../views/AppController';
import { get as loadView } from '../views/Views';
import CatalogItems from '../model/CatalogItems';
import ShoppingCart from '../model/ShoppingCart';
import UserProfile from '../model/UserProfile';
import cssVars from 'css-vars-ponyfill';


export default class App {

    constructor() {
        this.internal = {};
    }

    get config() { return this.internal.config; }
    set config(config) { this.internal.config = config; }

    get pageModel() { return this.internal.pageModel; }
    set pageModel(pageModel) { this.internal.pageModel = pageModel; }

    get rootElement() { return this.internal.rootElement; }
    set rootElement(rootElement) { this.internal.rootElement = rootElement; }

    get view() { return this.internal.view; }
    set view(view) { this.internal.view = view; }

    get contentView() { return this.internal.contentView; }
    set contentView(contentView) { this.internal.contentView = contentView; }

    get contentRouter() { return this.internal.contentRouter; }
    set contentRouter(contentRouter) { this.internal.contentRouter = contentRouter; }

    init() {

        this.shoppingCart = new ShoppingCart(this.pageModel.currentShoppingCart);
        this.pageShoppingCart = new ShoppingCart(this.pageModel.shoppingCart);

        this.userProfile = new UserProfile(this.pageModel.userProfile);

        const productComparisonListKeyName = this.getProductComparisonListKeyName();
        this.productComparisonList = new CatalogItems(AppStorage.get(productComparisonListKeyName));
        this.productComparisonList.on('all', () => AppStorage.set(productComparisonListKeyName, this.productComparisonList));

        this.view = new AppController({ el: this.rootElement });
        this.view.initPartials();

        const contentViewElement = this.getContentViewElement(this.rootElement);
        const contentViewClass = this.getContentViewClass(contentViewElement);
        cssVars(); // makes css cariables usable in IE11

        return loadView(contentViewClass)
            .then(({ Controller, Router }) => {
                if (!_.isUndefined(Controller)) {
                    this.contentView = new Controller({ el: contentViewElement });
                }

                if (!_.isUndefined(Router)) {
                    this.contentRouter = new Router();
                    Backbone.history.start();
                }
            });
    }

    getUserProfile() {
        return this.userProfile;
    }

    getProductComparisonList() {
        return this.productComparisonList;
    }

    getProductComparisonListKeyName() {
        return `productComparisonList-${this.userProfile.get('id')}-${this.userProfile.get('portalCustomerId')}`;
    }

    getShoppingCart() {
        return this.shoppingCart;
    }

    getPageShoppingCart() {
        return this.pageShoppingCart;
    }

    getContentViewElement(rootElement) {
        return $(rootElement)
            .find('#main > article:first-child');
    }

    getContentViewClass(contentViewElement) {
        // get content view name from article element
        const viewName = contentViewElement
            .attr('class')
            .split(' ')[0];
        return viewName;
    }

}


// WEBPACK FOOTER //
// ./core/App.js